export const DEFAULT_INVOICE_LANGUAGE = 'en'
